<template>
  <div>
    <!-- search button -->
    <div class="pt-3" />
    <div>
      <b-row class="align-items-end mb-2">

        <!-- Batch selector -->
        <b-col md="3">
          <label for="batch-filter"><b>Select Batch:</b></label>
          <b-form-select
            id="batch-filter"
            v-model="selectedBatch"
            :options="['B03', 'B04', 'B05', 'B06', 'B07', 'B08']"
            :placeholder="'Select a batch'"
          />
        </b-col>

        <!-- Intake selector -->
        <b-col md="3">
          <label for="intake-filter"><b>Select Intake:</b></label>
          <b-form-select
            id="intake-filter"
            v-model="selectedIntake"
            :options="['01', '02']"
            :placeholder="'Select an intake'"
          />
        </b-col>

        <!-- Reset Filters -->
        <b-col md="1">
          <b-button
            variant="success"
            class="d-flex align-items-center"
            style="height: 39px"
            @click="clearFilters"
          >
            <feather-icon
              icon="RotateCcwIcon"
              size="18"
            />
          </b-button>
        </b-col>

        <!-- Set Attendance -->
        <b-col md="4">
          <b-button
            variant="primary"
            class="w-100"
            style="height: 39px"
            @click="$refs.openAttendence.show()"
          >
            Set Today Attendance
          </b-button>
        </b-col>
      </b-row>

      <!-- Select User -->
      <b-row class="mb-2">
        <b-col md="6">
          <v-select
            id="paymentuser"
            v-model="selecteduser"
            :options="filteredUsers"
            label="name"
            style="background-color: white"
            @input="loadAttendences"
          />
        </b-col>
      </b-row>
    </div>

    <div class="pt-2" />
    <h3 class="text-primary font-weight-bold mb-2">
      Attendance Summary
    </h3>

    <!-- show selected user Batch and Intake -->
    <div
      v-if="this.selecteduser.name !== null"
      class="paid_months"
    >
      <span class="title">{{ selecteduser.name }} -> Batch
        <span class="font-weight-bold">{{ selecteduser.batch }} </span> and
        Intake
        <span class="font-weight-bold">{{ selecteduser.intake }} </span>
      </span>
    </div>

    <!-- full Attendance count -->
    <div class="pt-2" />

    <div
      v-if="this.selecteduser.name !== null"
      class="paid_months"
    >
      <span class="title">
        <span class="font-weight-bold">{{ selecteduser.batch }} </span> -
        <span class="font-weight-bold">{{ selecteduser.intake }} </span>
        Full Attendence Count:
        <span class="font-weight-bold">{{ fullattendences }}</span>
      </span>
    </div>

    <!-- selectted User Attendence -->
    <div class="pt-2" />

    <div
      v-if="this.selecteduser.name !== null"
      class="paid_months"
    >
      <span class="title">Attendence Count For {{ selecteduser.name }} :
        <span
          v-if="attendencescount !== null"
          class="font-weight-bold"
        >{{
          attendencescount
        }}</span>

        <span v-else>N/A</span>
      </span>
    </div>
    <!-- selectted User Attendence Percentage-->
    <div class="pt-2" />

    <div
      v-if="this.selecteduser.name !== null"
      class="paid_months"
    >
      <span class="title">{{ selecteduser.name }} 's Attendence Percentage:
        <span class="font-weight-bold">{{ getFloatValue(attendencespercentage) }}%</span>
      </span>
    </div>
    <!-- Attendence accesible Status -->
    <div class="pt-2" />

    <div
      v-if="this.selecteduser.name !== null"
      class="paid_months"
    >
      <span class="title">Attendence accesible Status:
        <span class="font-weight-bold">{{ accesible_staus }}</span>
      </span>
    </div>

    <div class="pt-3" />

    <div v-if="this.selecteduser.name !== null">
      <!-- payment table -->
      <AttendencesTable :attendences="attendences" />
    </div>

    <b-modal
      ref="openAttendence"
      hide-footer
      title="Set Today Attendence"
    >
      <div>
        <v-select
          id="attendencestatus"
          v-model="selectedstatus"
          :options="statuses"
          style="background-color: white"
          label="status"
        />
        <br>
        <b-button
          variant="primary"
          block
          @click="submitAttendence()"
        >
          Submit</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>

import vSelect from 'vue-select'
import AttendencesTable from '@/views/AttendenceManagement/Components/AttendenceTable.vue'
import attendencesApi from '@/Api/Modules/attendence'
import usersApi from '@/Api/Modules/auth'
import {
  BCol, BRow, BButton, BModal, BFormSelect,
} from 'bootstrap-vue'

export default {
  components: {

    vSelect,
    BModal,
    BButton,
    AttendencesTable,
    BCol,
    BRow,
    BFormSelect,
  },

  data() {
    return {
      selectedBatch: null,
      selectedIntake: null,
      attendencescount: '',
      attendencespercentage: '',
      fullattendences: '',
      accesible_staus: '',
      attendences: [],
      selecteduser: {
        name: 'Select User',
      },
      users: [],
      statuses: [
        {
          status: 'Enable',
        },
        {
          status: 'Disable',
        },
      ],
      selectedstatus: {
        status: 'Enable',
      },
    }
  },

  computed: {
    // Filter users by the currently selected batch and intake.
    filteredUsers() {
      return this.users.filter(user => {
        const batchMatch = this.selectedBatch
          ? user.batch === this.selectedBatch
          : true
        const intakeMatch = this.selectedIntake
          ? user.intake === this.selectedIntake
          : true
        return batchMatch && intakeMatch
      })
    },
  },
  watch: {
    // Reset the selected user when the batch filter changes.
    selectedBatch() {
      this.selecteduser = { name: 'Select User' }
    },
    // Reset the selected user when the intake filter changes.
    selectedIntake() {
      this.selecteduser = { name: 'Select User' }
    },
  },
  // Load the initial user and attendance data when the page opens.
  async created() {
    await this.initializeData()
  },

  methods: {
    // Return the custom padding class used by attendance table cells.
    setCellPadding(value, key, item) {
      return 'custom-cell-padding'
    },

    // Load users first and then load attendance data when users are available.
    async initializeData() {
      await this.Users()

      // // load payments
      if (this.users.length !== 0) {
        await this.AllAttendences()
      }
    },
    // Fetch users and select the first available user.
    async Users() {
      await this.$vs.loading({
        scale: 0.8,
      })

      const res = await usersApi.allUsers()
      this.users = res.data.data
      if (this.users.length === 0) {
        this.selecteduser.name = 'Select User'
      } else {
        this.selecteduser = this.users[0]
      }

      this.$vs.loading.close()
    },

    // Reload attendance data for the selected user.
    async loadAttendences() {
      await this.AllAttendences()
    },

    // Fetch the attendance summary for the selected user, batch, and intake.
    async AllAttendences() {
      const payload = {
        user_id: this.selecteduser.id,
        batch: this.selecteduser.batch, // add batch and intake
        intake: this.selecteduser.intake,
      }
      console.log('Payload to get all attendences:', payload)
      if (!payload.batch || !payload.intake) {
        console.warn(' Batch or Intake missing for selected user.')
        return
      }
      await this.$vs.loading({ scale: 0.8 })

      const res = await attendencesApi.allAttendences(payload)

      this.attendences = res.data.data.user_attendeces
      this.attendencescount = res.data.data.user_attended_count
      this.fullattendences = res.data.data.full_attended_count
      this.attendencespercentage = res.data.data.user_attended_percentage
      this.accesible_staus = res.data.data.accesible_staus

      this.$vs.loading.close()
    },

    // Submit today's attendance status for the selected batch and intake.
    async submitAttendence() {
      // Only continue if both batch and intake are selected
      if (!this.selectedBatch || !this.selectedIntake) {
        alert('Please select both batch and intake')
        return
      }

      const payload = {
        status: this.selectedstatus.status,
        batch: this.selectedBatch,
        intake: this.selectedIntake,
      }

      this.$vs.loading({ scale: 0.8 })

      try {
        await attendencesApi.updateAttendenceSummary(payload)

        await this.AllAttendences()
      } finally {
        this.$vs.loading.close()
      }
    },

    // Clear attendance filters, selection, and summary values.
    clearFilters() {
      // reset intake and batch selectors
      this.selectedBatch = null
      this.selectedIntake = null

      // reset User
      this.selecteduser = {
        name: 'Select User',
        id: null,
      }

      this.attendences = []
      this.attendencescount = ''
      this.fullattendences = ''
      this.attendencespercentage = ''
      this.accesible_staus = ''
    },
  },
}
</script>
